var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import API from '../api';
import { useChuckClientContext } from './useChuckClientContext';
import { useUserContext } from './useUserContext';
export const useAPI = () => {
    const { client } = useChuckClientContext();
    const { token } = useUserContext();
    const methods = useMemo(() => {
        return {
            get: (_a) => {
                var { url } = _a, args = __rest(_a, ["url"]);
                return API.get(Object.assign({ url: client.formatUrl(url), token }, args));
            },
            post: (_a) => {
                var { url } = _a, args = __rest(_a, ["url"]);
                return API.post(Object.assign({ url: client.formatUrl(url), token }, args));
            },
            patch: (_a) => {
                var { url } = _a, args = __rest(_a, ["url"]);
                return API.patch(Object.assign({ url: client.formatUrl(url), token }, args));
            },
            del: (_a) => {
                var { url } = _a, args = __rest(_a, ["url"]);
                return API.del(Object.assign({ url: client.formatUrl(url), token }, args));
            }
        };
    }, [token]);
    return methods;
};
//# sourceMappingURL=useAPI.js.map